import GoogleMapReact from 'google-map-react';
import config from '../config';
import React, { ReactNode } from 'react';
import googleMapReact from 'google-map-react';

export interface Props extends Partial<googleMapReact.Props> {
  className?: string;
  children?: ReactNode;
}

export default function Map(props: Props) {
  return (
    <div className={props.className} style={{ height: '100%', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: config.maps.apiKey }}
        {...props}
      />
    </div>
  );
}
